import { PostWalletRequest } from '@aaa-ncnu-ie/mypolicy-api-billing';
import { AxiosError } from 'axios';

import axios from '../axios';

export interface AddToWalletArgs {
  account: PostWalletRequest;
  ownerId: string;
}

export const addToWallet = async ({ account, ownerId }: AddToWalletArgs) => {
  try {
    if (!ownerId) {
      throw new Error('Missing ownerId');
    }

    const requestBody: PostWalletRequest = {
      ownerID: ownerId,
      account,
    };

    const { data } = await axios.post<void>(
      `${import.meta.env.VITE_MYPOLICY_BILLING_API_URL}/v1/wallet`,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          'x-api-key': import.meta.env.VITE_X_API_KEY ?? '',
        },
      }
    );

    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError?.response?.status === 404) {
      return axiosError.response.data;
    }
    return error;
  }
};
